// File: AppointmentOfAuditor.jsx
import React from "react";

export default function AppointmentOfAuditor() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Appointment of Auditor
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages auditor appointment filings with MCA.
          </p>
          <p className="text-gray-700">
            Complete auditor appointment process including Form ADT-1 filing, board resolutions, consent letters, eligibility verification, MCA portal submissions, and statutory compliance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Auditor appointment - accounting/audit professional) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Auditor appointment compliance - MCA Form ADT-1 filing"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless MCA auditor appointment filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Board resolution for auditor appointment</li>
                <li>Auditor consent letter (Form ADT-1)</li>
                <li>Declaration of eligibility</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Statutory accuracy assured with proven expertise in Companies Act compliance and MCA filings.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  MCA Form ADT-1 Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Form ADT-1 preparation and filing within 15 days of board meeting, auditor eligibility verification as per Section 141, consent letter formatting, MCA V3 portal submission, and SRN tracking.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Board Resolution Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise board meeting documentation, Section 139 compliance verification, rotation requirements for listed companies, ratification processes, and statutory register updates for seamless auditor appointments.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Filing Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service auditor appointment from board resolution drafting through MCA approval, auditor communication coordination, DIN verification, statutory record maintenance, penalty avoidance advisory, and compliance tracking.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
